import { render, staticRenderFns } from "./manager-search.vue?vue&type=template&id=21534460&"
import script from "./manager-search.vue?vue&type=script&lang=js&"
export * from "./manager-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports